import {
    PlatformNavbar,
    PlatformNavbarMode
} from "@flexinet/ui-components";
import {getMenuItems} from "../data/menus.tsx";
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {ScrollArea} from "@mantine/core";

export const PortalNavbar = (
    {
        mode,
        changeMode
    }: {
        mode: PlatformNavbarMode,
        changeMode: (mode: PlatformNavbarMode) => void
    }) => {

    const {allowedActions} = useVerifiedPermissions()

    const items = getMenuItems()

    const menuItems = items.filter((item) => {
        return allowedActions.includes(item.rbac as string)
    });


    return <ScrollArea>
        <PlatformNavbar
            appTitle={"Billing Console"}
            menuItems={menuItems}
            mode={mode}
            changeMode={changeMode}

        /></ScrollArea>

};